export default __webpack_public_path__ + "static/media/disputes.efc329bf.png";